import GlobalVariables from '../GlobalVariables';

const ADACompliant = {
    push(elements) {
        GlobalVariables.ADAElements.push(elements);
        return this;
    },
    apply() {
        if (GlobalVariables.ADAElements.length > 0) {
            for (let j = 0; j < GlobalVariables.ADAElements[0].length; j++) {
                GlobalVariables.ADAElements[0][j].setAttribute(
                    'tabindex',
                    GlobalVariables.tabIndexCount
                );
            }
            this.clearArray();
        }
    },
    clearArray() {
        GlobalVariables.ADAElements = [];
    }
};
export default ADACompliant;
